export default class Payment {
  constructor(data) {
    this.additionalInformation = data.additional_information;
    this.allowQrCode = data.allow_qr_code;
    this.chargeCurrency = data.charge_currency;
    this.chargeType = data.charge_type;
    this.description = data.description;
    this.fee_percent = data.fee_percent;
    this.icon = data.icon;
    this.id = data.id;
    this.maxAmount = data.max_amount;
    this.minAmount = data.min_amount;
    this.name = data.name;
    this.paymentQrCode = data.payment_qr_code;
    this.publicFields = data.public_fields;
    this.strategy = data.strategy;
    this.paymentMethodBonuses = data.payment_method_bonuses;
  }
}
